import { BooleanInput, Create, SelectInput, SimpleForm, TextInput, required } from 'react-admin';
import { ColorInput, Permission } from '../../components';
import { PERMISSIONS } from '../../constants';
import { TagType } from '../../models';

const CreateTag = (props) => {
  return (
    <Permission permission={PERMISSIONS.TAG}>
      <Create {...props} title="Criar Etiqueta">
        <SimpleForm sx={{ maxWidth: 600 }}>
          <TextInput source="name" label="Nome" validate={[required()]} sx={{ minWidth: 300 }} />
          <SelectInput
            label="Tipo"
            source="type"
            choices={TagType.tagTypeChoices}
            validate={[required()]}
            sx={{ minWidth: 300 }}
          />
          {/* cor é obrigatória no backend (Joi.string().required()); sem default o campo vazio mandava 400 */}
          <ColorInput source="color" label="Cor principal" validate={[required()]} defaultValue="#1976d2" />
          <Permission permission={PERMISSIONS.DRAWING}>
            <BooleanInput source="canRedeemLuckyNumber" label="Pode participar de sorteios" defaultValue />
          </Permission>
        </SimpleForm>
      </Create>
    </Permission>
  );
};

export default CreateTag;